import { render, staticRenderFns } from "./VisitaControlloEcgList.vue?vue&type=template&id=76cfedb2"
import script from "./VisitaControlloEcgList.vue?vue&type=script&lang=js"
export * from "./VisitaControlloEcgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports